import * as React from 'react';
import styled from 'styled-components';
import { IContextMenuProps } from './context-menu-types';
import { Callout } from '../../callout';
import { FlyoutMenu } from '../flyout-menu';
import { renderClasses } from '@agilepoint/utils-common';

const StyledCallout = styled(Callout)`
    .ap-Callout-Content {
        overflow: visible;
        padding: 0;
        width: 100%;
        height: 100%;
    }

    ${FlyoutMenu} {
        border: none;
    }
`;

export const ContextMenu = React.memo((props: IContextMenuProps) => {
    const { className, items, targetRef, onChange } = props;
    const [isMenuHidden, setHiddentState] = React.useState(true);
    const [pointerPosition, setPointerPosition] = React.useState({
        clientX: 0,
        clientY: 0
    });

    const _onContextMenu = React.useCallback((e: MouseEvent) => {
        e.preventDefault();
        const { clientX, clientY } = e;
        setHiddentState(false);
        setPointerPosition({ clientX, clientY });
    }, []);

    React.useEffect(() => {
        const target = targetRef.current;
        target?.addEventListener('contextmenu', _onContextMenu);
        return () => target?.removeEventListener('contextmenu', _onContextMenu);
    }, [_onContextMenu, targetRef]);

    const hideMenu = React.useCallback(() => {
        setHiddentState(true);
    }, []);

    return (
        <StyledCallout
            pointerPosition={pointerPosition}
            hidden={isMenuHidden}
            onDismiss={hideMenu} >
            <FlyoutMenu
                className={renderClasses(['ap-contextMenu'], className)}
                items={items}
                onChange={onChange} />
        </StyledCallout>
    );
});

ContextMenu.displayName = 'ContextMenu';
